import "./styles.scss"

function setupSliders() {
    function setupSlider(sliderEl: HTMLElement) {
        const prevEl = sliderEl.querySelector<HTMLButtonElement>("[data-slider-prev]")
        const nextEl = sliderEl.querySelector<HTMLButtonElement>("[data-slider-next]")
        const markersEl = sliderEl.querySelector<HTMLElement>("[data-slider-markers]")
        const trackEl = sliderEl.querySelector<HTMLElement>("[data-slider-track]")
        const controlEl = sliderEl.querySelector<HTMLElement>("[data-slider-control]")

        if (!trackEl) throw `Slider doesn't have a track`

        // Check the number of slides in the track
        const slideCount = trackEl.children.length

        // Show or hide controls based on the number of slides
        if (controlEl) {
            controlEl.hidden = slideCount <= 1
        }

        if (slideCount <= 1) return

        if (prevEl) prevEl.onclick = () => slide("prev")
        if (nextEl) nextEl.onclick = () => slide("next")

        trackEl.addEventListener("scroll", updateButtons, { passive: true })
        addEventListener("resize", updateButtons, { passive: true })
        markersEl?.addEventListener("click", handleMarkerClick)

        function slide(dirOrPage: "next" | "prev" | number) {
            const { scrollLeft, clientWidth } = trackEl!

            let left = scrollLeft
            if (dirOrPage === "next") {
                left += clientWidth
            } else if (dirOrPage === "prev") {
                left -= clientWidth
            } else {
                left = clientWidth * dirOrPage
            }

            trackEl!.scroll({ left, behavior: "smooth" })
        }

        function updateButtons() {
            const { scrollLeft, clientWidth, scrollWidth } = trackEl!

            const items = markersEl?.querySelectorAll("[data-slider-marker]")
            const totalEl = sliderEl.querySelector<HTMLElement>("[data-slider-total]")
            const numberEl = sliderEl.querySelector<HTMLElement>("[data-slider-n]")

            // update items current state
            const activeMarkerIdx = Math.round(scrollLeft / clientWidth)
            if (items?.length) {
                items.forEach((item, idx) => {
                    item.setAttribute("aria-current", idx === activeMarkerIdx ? "true" : "false")
                })
            }

            // update prev/next disabled state
            if (prevEl) prevEl.disabled = scrollLeft === 0

            // update current item
            // currentAlgumaCoisa = elemento que recebe o item atual
            if (numberEl) {
                numberEl.textContent = (activeMarkerIdx + 1).toString()
            }

            // update total count
            if (totalEl && trackEl?.children.length) {
                totalEl.textContent = trackEl?.children.length.toString()
                if (nextEl) nextEl.disabled = activeMarkerIdx + 1 >= trackEl?.children.length
            }
        }

        function handleMarkerClick(e: MouseEvent) {
            const target = e.target as HTMLElement
            const clickedEl = target.closest("[data-slider-marker]") as HTMLElement | null
            const page = clickedEl?.dataset.sliderMarker as "next" | "prev"
            if (page) slide(page)
        }

        updateButtons()
    }

    document.querySelectorAll<HTMLElement>("[data-slider]").forEach((el) => setupSlider(el))
}

setupSliders()
